/*
 * ******************************************************************
 * Copyright (c) 2022-2025 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */
import { AfterViewInit, Directive, ElementRef } from "@angular/core";

// @formatter:off
@Directive({
    standalone: false,
   selector: "[units-format]"
})
// @formatter:on
export class UnitsFormatDirective implements AfterViewInit {

    readonly units = ["TiBs", "VMs", "subscriptions"];
    readonly anyNumberRegex = /[-.0-9]+/g;
    readonly lastDigitRegex = /.$/;

    constructor(private elRef: ElementRef) {
    }

    public ngAfterViewInit(): void {
        const innerText = this.elRef.nativeElement.innerText;
        const checkForNumbers = innerText.match(this.anyNumberRegex);

        this.units.forEach(unit => {
            const singleUnit = unit.replace(this.lastDigitRegex, "");
            if (innerText.search(unit) > 0 &&
                checkForNumbers[checkForNumbers.length - 1] == 1
            ) {
                this.elRef.nativeElement.innerText = innerText.replace(unit, singleUnit);
            }
        });

        // reformat originalValue up to the 3rd floating point
        const thirdFloatingPoint = Number.parseFloat(checkForNumbers[0]).toFixed(3);

        // check if the number is not integer in order to format up to the 3rd floating point
        if (!Number.isInteger(Number(checkForNumbers[0]))) {
            this.elRef.nativeElement.innerText = innerText.replace(checkForNumbers[0], thirdFloatingPoint);
        }
    }
}
